import React, { useEffect, useMemo, useState } from 'react';
import {
  FilterButton,
  FilterGroup,
  ProjectsContainer,
  ProjectsMessage,
  ProjectsMeta,
  SectionHeading,
  SectionTitle,
  StyledProjects
} from '../../Styled/ProjectStyled/Project.styled';
import { StyledLink, StyledParagraph } from '../../Styled/Typograpystyle/Typography.style';
import ProjectCardComponent from './Projectcard';

const filters = [
  { id: 'all', label: 'All vibes', emoji: '✨' },
  { id: 'vibe', label: 'Vibe Labs', emoji: '🌈' },
  { id: 'nextjs', label: 'Next.js', emoji: '⚡' },
  { id: 'mern', label: 'MERN', emoji: '🛰️' },
];

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [activeFilter, setActiveFilter] = useState('all');
  const [status, setStatus] = useState({ loading: true, error: null });

  useEffect(() => {
    const controller = new AbortController();

    const fetchProjects = async () => {
      setStatus({ loading: true, error: null });
      try {
        const response = await fetch('/data/projects.json', { signal: controller.signal });
        if (!response.ok) {
          throw new Error('Unable to load the latest case studies.');
        }
        const payload = await response.json();
        setProjects(payload);
        setStatus({ loading: false, error: null });
      } catch (error) {
        if (error.name === 'AbortError') return;
        setStatus({ loading: false, error: error.message });
      }
    };

    fetchProjects();

    return () => controller.abort();
  }, []);

  const filteredProjects = useMemo(() => {
    if (activeFilter === 'all') return projects;
    return projects.filter((project) => project.category === activeFilter);
  }, [projects, activeFilter]);

  return (
    <StyledProjects id="projects">
      <SectionHeading>
        <SectionTitle number="01">Projects</SectionTitle>
      </SectionHeading>
      <StyledParagraph dark="true" textAlign="center">
        Gen-Z ready builds crafted across vibe coding labs, Next.js launches, and MERN ship rooms.{" "}
        <StyledLink
          href="https://github.com/Enamhossain"
          target="_blank"
          rel="noopener noreferrer"
        >
          Want the full drop?
        </StyledLink>
      </StyledParagraph>

      <ProjectsMeta>
        <span>Stack focus →</span>
        <FilterGroup role="tablist" aria-label="Project category filters">
          {filters.map((filter) => (
            <FilterButton
              key={filter.id}
              type="button"
              onClick={() => setActiveFilter(filter.id)}
              aria-pressed={activeFilter === filter.id}
              data-active={activeFilter === filter.id}
            >
              {filter.emoji} {filter.label}
            </FilterButton>
          ))}
        </FilterGroup>
      </ProjectsMeta>

      {status.loading && <ProjectsMessage>Pulling fresh case studies…</ProjectsMessage>}
      {status.error && !status.loading && (
        <ProjectsMessage role="alert" data-variant="error">
          {status.error}
        </ProjectsMessage>
      )}

      {!status.loading && !status.error && (
        <ProjectsContainer>
          {filteredProjects.map((project) => (
            <ProjectCardComponent key={project.id} {...project} />
          ))}
        </ProjectsContainer>
      )}
    </StyledProjects>
  );
};

export default Projects;